import React from 'react'
import Yup from '../../../../helpers/custom-yup'
import Title from '../../../../components/typography/title.component'
import banner from '../../../../../assets/images/banners-club/desktop.png'
import Button from '../../../../components/buttons/buttons.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component'
import bannerMobile from '../../../../../assets/images/banners-club/mobile.png'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { Formik } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { isMobile } from '../../../../helpers'
import { PlansTable } from '../../../../components/layout/plans-table/plans-table.component'
import { withRouter } from 'react-router-dom'
import { ClubService } from '../../../../services/club.service'
import { BillingAddress } from '../../../../components/form-components/address-manager/billing-address.component'
import { bindActionCreators } from 'redux'
import { CheckboxToggleInput } from '../../../../components/form-components/inputs.component'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import { toastActions, userActions } from '../../../../actions'
import { paymentFieldsInitialValues } from '../../../../components/form-components/payment-fields/payment-fields.component'
import PaymentFields, {
	paymentFieldsYupSchemaRecurrent
} from '../../../../components/form-components/payment-fields/payment-fields.component'

class PlansPage extends React.Component {
	constructor(props) {
		super(props)
		if (props.userPlan !== null) {
			props.history.push(`${routes.CLIENTE}/meu-plano`)
		}

		this.state = {
			selectedPlanId: null,
			recurrenceType: null
		}
	}

	componentDidMount() {
		this.props.setPaymentMethod('creditCard')
	}

	onPlanSelect = (id, type) =>
		this.setState({ selectedPlanId: id, recurrenceType: type })

	onSubmit = async ({
		acceptTerms,
		cardMonthValidity,
		cardNumber,
		cardPrintedName,
		cardYearValidity,
		recurrentPayDay,
		securityCode,
		savecard
	}) => {
		const { selectedPlanId, recurrenceType } = this.state
		const {
			danger,
			deviceId,
			addresses,
			showLoading,
			hideLoading,
			history,
			updatePlan
		} = this.props

		const data = {
			planId: selectedPlanId,
			addressId: addresses.filter(address => address.billingAddress)[0].id,
			termsAndConditionsRead: acceptTerms,
			deviceId,
			creditCard: {
				holderName: cardPrintedName,
				number: cardNumber,
				expirationMonth: cardMonthValidity,
				expirationYear: cardYearValidity,
				securityCode,
				savecard
			},
			recurrenceType: recurrenceType,
			billingDay: recurrentPayDay
		}

		if (!selectedPlanId) {
			danger({ message: 'Escolha um plano' })
			return
		}

		showLoading()

		ClubService.subscribe(data)
			.then(({ data, success, errors }) => {
				hideLoading()
				if (success) {
					updatePlan()
					history.push(`${routes.CLIENTE}/clube-sucesso`, {
						orderNumber: data.orderNumber,
						name: data.name,
						email: data.email
					})
				} else {
					danger({ message: errors[0] })
				}
			})
			.catch(error => {
				hideLoading()
				danger({ message: 'Não foi possivel finalizar a assinatura' })
			})
	}

	render() {
		const { selectedPlanId, recurrenceType } = this.state
		const { clientId } = this.props

		return (
			<InnerPageContainer>
				<AntiFraud />
				<Title>Clube Muviflex</Title>

				{isMobile() ? (
					<img
						src={bannerMobile}
						alt="Banner planos do clube muviflex"
						style={{ width: '100%' }}
					/>
				) : (
						<img
							src={banner}
							alt="Banner planos do clube muviflex"
							style={{ width: '100%' }}
						/>
					)}

				<h3 className="orange semi-bold">
					Confira as opções de planos disponíveis
				</h3>

				<PlansTable
					selectedPlanId={selectedPlanId}
					notBuyable
					selectable
					onSelect={this.onPlanSelect}
				/>

				<h3 className="orange semi-bold">Endereço de cobrança</h3>

				<BillingAddress clientId={clientId} />

				<h3 className="orange semi-bold">Dados de pagamento</h3>

				<Formik
					onSubmit={this.onSubmit}
					initialValues={{
						acceptTerms: false,
						...paymentFieldsInitialValues({ recurrent: true })
					}}
					validationSchema={Yup.object().shape({
						acceptTerms: Yup.mixed()
							.oneOf([true], 'Aceite os termos')
							.required('Aceite os termos'),
						...paymentFieldsYupSchemaRecurrent
					})}
					render={props => (
						<form noValidate onSubmit={props.handleSubmit}>
							<div style={{ maxWidth: '600px' }}>
								<PaymentFields
									recurrent={recurrenceType === 'monthly'}
									noBankSlip
									noMuvicard
									noPaymentMethodButtons
									noInstallments
									{...props}
								/>
							</div>

							<p>
								Declaro que li e concordo com os{' '}
								<AnchorButton href="/regulamento" noStyle targetBlank>
									termos e condições de uso
								</AnchorButton>{' '}
								do programa Muviflex <span className="orange">*</span>
							</p>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<CheckboxToggleInput id="acceptTerms" {...props} />
								<div
									style={{
										marginLeft: '15px',
										fontSize: '18px'
									}}>
									{props.values.acceptTerms ? 'Sim' : 'Não'}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									marginTop: '4rem'
								}}>
								<Button
									secondary
									type="button"
									style={{ marginRight: '15px' }}>
									Cancelar
								</Button>
								<Button primary type="submit">
									Confirmar assinatura
								</Button>
							</div>
						</form>
					)}
				/>
			</InnerPageContainer>
		)
	}
}

const mapStateToProps = ({ user, antiFraud, addresses }) => ({
	clientId: user.id,
	userPlan: user.plan,
	deviceId: antiFraud.sessionID,
	...addresses
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			updatePlan: userActions.updatePlan,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			setPaymentMethod: TicketSaleCreators.paymentMethod
		},
		dispatch
	)

const connectedPlansPage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PlansPage)
)

export { connectedPlansPage as ModuleRootComponent }
